import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import api from '../utils/api.js'
import type { CalToken } from '../types/domain'

// React Query hooks for the multi-token cal-feed API at /api/cal/tokens.
// Legacy single-token endpoints (/api/cal/token) are still served by the
// backend through the deprecation window — those are NOT used here; new UI
// goes through the plural endpoints to support per-device + scoped feeds.

type Id = number | string

interface IssueCalTokenInput {
  label: string
  scope_kind: string
  scope_id?: Id | null
  expires_at?: string | null
}

const QUERY_KEY = ['calTokens'] as const

export function useCalTokens() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => api.get<CalToken[]>('/cal/tokens').then(r => r.data),
  })
}

export function useIssueCalToken() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ label, scope_kind, scope_id = null, expires_at = null }: IssueCalTokenInput) =>
      api.post<CalToken>('/cal/tokens', { label, scope_kind, scope_id, expires_at }).then(r => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  })
}

export function useRevokeCalToken() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: Id) => api.delete(`/cal/tokens/${id}`).then(r => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  })
}
